const menu = document.querySelector('.menu');

if (menu) {
  const closeOpenDropdown = () => {
    document.querySelectorAll('.menu__item.has-submenu.is-open-submenu').forEach((item) => {
      item.classList.remove('is-open-submenu');
      slideUp(item.querySelector('.menu__dropdown'), 300, 'none');
    });
  };

  CustomEase.create('customEase', '0.16, 1, 0.3, 1');

  const menuAnimation = gsap.to(['.menu__link.level-1', '.menu__footer .btn', '.site-header__language-btn'], {
    y: 0,
    duration: 0.6,
    stagger: 0.05,
    ease: 'customEase',
    paused: false,
  });

  const toggleMenuClass = (toggle) => {
    document.body.classList.toggle('is-open-menu', toggle);
    toggleBodyScrollLock(toggle);

    if (toggle) {
      menuAnimation.restart();
    }
  };

  attachEvent('.hamburger', 'click', () => {
    const isOpen = document.body.classList.contains('is-open-menu');
    toggleMenuClass(!isOpen);

    setTimeout(() => {
      closeOpenDropdown();
    }, 300);
  });

  // Toggle Submenu

  attachEvent('.menu__item.has-submenu .menu__link.level-1', 'click', (ev) => {
    ev.preventDefault();

    const menuItem = ev.target.closest('.menu__item');
    const dropdown = menuItem.querySelector('.menu__dropdown');
    const openItem = document.querySelector('.menu__item.is-open-submenu');
    const isOpen = menuItem.classList.contains('is-open-submenu');

    // Close the currently open item
    if (isOpen) {
      menuItem.classList.remove('is-open-submenu');
      slideUp(dropdown, 200);
      return;
    }

    // Close another open item first
    if (openItem) {
      slideUp(openItem.querySelector('.menu__dropdown'), 200);
      openItem.classList.remove('is-open-submenu');

      setTimeout(() => {
        menuItem.classList.add('is-open-submenu');
        slideDown(dropdown, 300);
      }, 200);
    } else {
      menuItem.classList.add('is-open-submenu');
      slideDown(dropdown, 300);
    }
  });
}
